import { AuthLayout, BaseLayout, PrivateLayout, PublicLayout } from "~/components/layouts";
import { BasicRoute, PrivateRoute } from "~/components/elements";
import { PAGES } from "~/constants";
import PrivacyPolicyPage from "~/pages/privacy-policy";
import ContactUsPage from "~/pages/contact-us/page/index";
import ContactSubmitted from "~/pages/contact-submitted/index";
import UnsubscribePage from "~/pages/unsubscribe";
import LoginPage from "~/pages/login";
import RegisterPage from "~/pages/register";
import DashboardPage from "~/pages/dashboard";
import LogoutPage from "~/pages/logout";
import ForgotPassword from "~/pages/forgot-password";
import ResultDetailPage from "~/pages/result-detail";
import TermsAndConditionsPage from "~/pages/terms-and-conditions";
import EmailConfirmation from "~/pages/register/email-confirmation";
import PaymentSuccessfulPage from "~/pages/payment-successful";
import PaymentFailedPage from "src/pages/payment-failed";
import { SurveyPage } from "~/pages/dashboard/welcome-step/SurveyPage";
import { SelectPackagePage } from "~/pages/dashboard/package-step/SelectPackagePage";
import { SelectStylePage } from "~/pages/dashboard/styles-step/SelectStylePage";
import { ViewResultPage } from "~/pages/dashboard/view-result";
import { KeyFeaturesPage } from "~/pages/dashboard/upload-step/KeyFeaturesPage";
import { UploadTipsPage } from "~/pages/dashboard/upload-step/UploadTipsPage";
import { UploadPhotoPage } from "~/pages/dashboard/upload-step/UploadPhotoPage";
import { CompletedPage } from "~/pages/dashboard/upload-step/CompletedPage";
import SharedJobPage from "~/pages/shared";
import VotingPage from "~/pages/votes";
import { UserProfilePage } from "~/pages/profile/UserProfilePage";

export const publicRoutes: BasicRoute[] = [
  {
    path: "/",
    component: PublicLayout,
    exact: true,
    routes: [
      // { path: "/", component: HomePage, exact: true },
      // {
      //   path: `/#pricing`,
      //   exact: true,
      //   label: "Pricing",
      // },
      // {
      //   path: `/#howitworks`,
      //   exact: true,
      //   label: "How it Works",
      // },
      // {
      //   path: `/#examples`,
      //   exact: true,
      //   label: "Examples",
      // },
      // {
      //   path: `/#styles`,
      //   exact: true,
      //   label: "Styles",
      // },
      // {
      //   path: `/#faqs`,
      //   exact: true,
      //   label: "FAQs",
      // },
      {
        path: PAGES.CONTACT_US,
        exact: true,
        component: ContactUsPage,
      },
      {
        path: `${PAGES.VOTES}/:slugId`,
        component: VotingPage,
        label: "Voting",
        exact: false,
      },
      {
        path: PAGES.UNSUBSCRIBE,
        exact: true,
        component: UnsubscribePage,
      },
      {
        path: PAGES.CONTACT_SUBMITTED,
        exact: true,
        component: ContactSubmitted,
      },
    ],
  },
  {
    path: `/s`,
    exact: false,
    component: BaseLayout,
    routes: [
      {
        path: `${PAGES.VOTES}/:slugId`,
        component: VotingPage,
      },
    ],
  },
  {
    path: `/l`,
    exact: false,
    component: BaseLayout,
    routes: [
      {
        path: `${PAGES.VOTES}/:slugId`,
        component: VotingPage,
      },
    ],
  },
  {
    path: "/p",
    component: AuthLayout,
    exact: false,
    routes: [
      { path: PAGES.LOGIN, component: LoginPage, exact: false },
      { path: PAGES.REGISTER, component: RegisterPage, exact: false },
      { path: PAGES.FORGOT_PASSWORD, component: ForgotPassword, exact: false },
      { path: PAGES.EMAIL_CONFIRMATION, component: EmailConfirmation, exact: false },
    ],
  },
  { path: PAGES.LOGOUT, component: LogoutPage, exact: true },
  { path: PAGES.TERMS_AND_CONDITIONS, component: TermsAndConditionsPage, exact: true },
  { path: PAGES.POLICY, component: PrivacyPolicyPage, exact: true },
];

export const privateRoutes: PrivateRoute[] = [
  {
    path: "/",
    component: PrivateLayout,
    exact: false,
    routes: [
      {
        path: PAGES.DASHBOARD,
        component: DashboardPage,
        label: "Dashboard",
        exact: false,
      },
      {
        path: PAGES.SURVEY,
        component: SurveyPage,
        label: "Survey",
        exact: false,
      },
      {
        path: PAGES.SELECT_PACKAGES,
        component: SelectPackagePage,
        label: "Package",
        exact: false,
      },
      {
        path: PAGES.SELECT_STYLES,
        component: SelectStylePage,
        label: "Style",
        exact: false,
      },
      {
        path: PAGES.KEY_FEATURES,
        component: KeyFeaturesPage,
        label: "Key Features",
        exact: false,
      },
      {
        path: PAGES.UPLOAD_TIPS,
        component: UploadTipsPage,
        label: "Upload Tips",
        exact: false,
      },
      {
        path: PAGES.UPLOAD_PHOTOS,
        component: UploadPhotoPage,
        label: "Upload Photos",
        exact: false,
      },
      {
        path: PAGES.COMPLETED,
        component: CompletedPage,
        label: "Completed",
        exact: false,
      },
      {
        path: PAGES.VIEW_RESULTS,
        component: ViewResultPage,
        label: "Results",
        exact: false,
      },
      {
        path: `${PAGES.RESULT_DETAIL}/:id`,
        component: ResultDetailPage,
        label: "Result Detail",
        exact: false,
      },
      {
        path: `${PAGES.PAYMENT_SUCCESSFUL}`,
        component: PaymentSuccessfulPage,
        label: "Payment Successful",
        exact: false,
      },
      {
        path: `${PAGES.PAYMENT_CANCELLED}`,
        component: PaymentFailedPage,
        label: "Payment Cancelled",
        exact: false,
      },
      {
        path: `${PAGES.SHARED}/:slugId`,
        component: SharedJobPage,
        label: "Shared",
        exact: false,
      },
      {
        path: PAGES.PROFILE,
        component: UserProfilePage,
        label: "My Profile",
        exact: false,
      },
    ],
  },
];
